import type { TFunction } from 'i18next';

/** Localized label for a tutor skill enum / API value; falls back to raw code if unknown. */
export function tutorSkillLabel(t: TFunction, skill: string): string {
  return t(`tutorSkills.${skill}`, { defaultValue: skill });
}

export function tutorSkillsList(t: TFunction, skills: string[] | null | undefined, emptyDash: string): string {
  if (!skills?.length) return emptyDash;
  return skills.map((s) => tutorSkillLabel(t, s)).join(', ');
}
